import EventUtils from '@/utils/EventUtils.js';
import UserEvents from '@/domain/model/user/UserEvents.js';

const state = {
    event: {},
    signUpEvent: {},
};

const getters = {
    register_event : state => state.event,
    register_signUpEvent : state => state.signUpEvent,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event && event.status == EventUtils.STATUS.COMPLETE &&
        event.eventName == UserEvents.SignUp.Names.Response) {
      state.signUpEvent = event;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
